import React, {ReactElement, useEffect, useState} from 'react';
import ToolbarNotificationService, {
  ToolbarNotificationShape,
} from '../../../services/ToolbarNotificationService';
import Table from '../../../components/SimpleTable';
import {useBoolean} from 'src/hooks/useBoolean';
import {formatDate} from '../../../apps/AdminUniversity/form/RecentDownloads';
import Button from '../../../components/button';
import history from 'shared/history';
import classnames from 'classnames';
import styles from './styles.module.scss';

const columns = [
  {
    value: 'Name',
  },
  {
    value: 'Active',
  },
  {
    value: 'Priority',
  },
  {
    value: 'User Groups',
  },
  {
    value: 'Platforms',
  },
  {
    value: 'Created At',
  },
  {
    value: 'Last Update',
  },
  {
    value: 'Actions',
  },
];

const deleteNotification = async (_id: string): Promise<void> => {
  await ToolbarNotificationService.destroy(_id);
  window.location.reload(); // TODO could replace this by nicely removing a row
};

const EditDeleteArea = ({notificationId}: {notificationId: string}): ReactElement => (
  <div className={classnames(styles.flexRow)}>
    <Button
      size="tiny"
      onClick={(): void => history.push(`${history.location.pathname}/${notificationId}`)}
      horizontalMargin
    >
      Edit
    </Button>
    <Button
      size="tiny"
      color="red"
      outline
      onClick={(): Promise<void> => deleteNotification(notificationId)}
    >
      Delete
    </Button>
  </div>
);

const ToolbarNotificationAdmin = (): ReactElement => {
  const [toolbarNotifications, setToolbarNotifications] = useState<ToolbarNotificationShape[]>([]);
  const loading = useBoolean(true);
  const rows = toolbarNotifications.map(
    ({
      _id,
      identifier,
      priority,
      active,
      includedUserGroups,
      includedPlatforms,
      createdAt,
      lastUpdatedBy,
      updatedAt,
    }) => [
      {value: identifier},
      {value: active ? 'Active' : 'Deactivated'},
      {value: priority},
      {
        value:
          Array.isArray(includedUserGroups) && includedUserGroups.length !== 0
            ? includedUserGroups?.join(', ')
            : 'N/A',
      },
      {
        value: (includedPlatforms?.length || 0) > 0 ? includedPlatforms?.join(', ') : 'N/A',
      },
      {value: formatDate(createdAt)},
      {
        value: `Last updated by ${lastUpdatedBy} at ${new Date(
          Date.parse(updatedAt)
        ).toLocaleString()}`,
      },
      {value: <EditDeleteArea notificationId={_id} />},
    ]
  );

  const fetchToolbarNotifications = async (): Promise<void> => {
    setToolbarNotifications(await ToolbarNotificationService.index());
  };

  useEffect(() => {
    fetchToolbarNotifications();
    loading.setFalse();
  }, []);

  return (
    <div>
      <Button
        size="medium"
        onClick={(): void => history.push('/admin/tools/toolbar-notifications/new')}
      >
        Create new
      </Button>
      <Table caption={<h2 className="shared-font subtitle">Toolbar Notifications</h2>}>
        <Table.Header columns={columns} />
        <Table.Body
          rows={rows}
          emptyState={{
            numberOfColumns: 8,
            text: loading.value ? 'Loading...' : 'No toolbars yet.',
          }}
        />
      </Table>
    </div>
  );
};

export default ToolbarNotificationAdmin;
